import React from "react";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  PUBLIC_PREFIX_PATH,
} from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/change-password"),
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/dashboard")),
    meta: {
      homeLayout: true,
    },
  },

  // Ringkasan
  {
    key: "ringkasan",
    path: `${APP_PREFIX_PATH}/ringkasan`,
    component: React.lazy(() => import("views/app-views/ringkasan")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "incomplete-data",
    path: `${APP_PREFIX_PATH}/incomplete-data`,
    component: React.lazy(() => import("views/app-views/incomplete-data")),
    meta: {
      homeLayout: true,
    },
  },
  // Data Pegawai
  {
    key: "data-pegawai",
    path: `${APP_PREFIX_PATH}/data-pegawai/:type/:id`,
    component: React.lazy(() => import("views/app-views/pegawai")),
  },
  {
    key: "data-pegawai-detail",
    path: `${APP_PREFIX_PATH}/data-pegawai/detail/:id`,
    component: React.lazy(() => import("views/app-views/pegawai/detail")),
  },
  {
    key: "data-pegawai-form",
    path: `${APP_PREFIX_PATH}/data-pegawai/form/:id?`,
    component: React.lazy(() => import("views/app-views/pegawai/form")),
  },
  // Data Pensiun
  {
    key: "pensiun",
    path: `${APP_PREFIX_PATH}/pensiun/:type/:id`,
    component: React.lazy(() => import("views/app-views/pensiun")),
  },
  // Data BKO
  {
    key: "bko",
    path: `${APP_PREFIX_PATH}/bko/:type/:id`,
    component: React.lazy(() => import("views/app-views/bko")),
  },
  {
    key: "hukdis",
    path: `${APP_PREFIX_PATH}/hukdis/:type/:id`,
    component: React.lazy(() => import("views/app-views/hukdis")),
  },
  // KGB
  {
    key: "kgb",
    path: `${APP_PREFIX_PATH}/kgb`,
    component: React.lazy(() => import("views/app-views/kgb")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "kgb-detail",
    path: `${APP_PREFIX_PATH}/kgb/detail/:id`,
    component: React.lazy(() => import("views/app-views/kgb/detail")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "kgb-form",
    path: `${APP_PREFIX_PATH}/kgb/form/:id?`,
    component: React.lazy(() => import("views/app-views/kgb/form")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "kgb-history",
    path: `${APP_PREFIX_PATH}/kgb/riwayat`,
    component: React.lazy(() => import("views/app-views/kgb/riwayat")),
    meta: {
      customLayout: true,
    },
  },
  // Penghargaan
  {
    key: "penghargaan",
    path: `${APP_PREFIX_PATH}/penghargaan`,
    component: React.lazy(() => import("views/app-views/penghargaan")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "penghargaan-detail",
    path: `${APP_PREFIX_PATH}/penghargaan/detail/:id`,
    component: React.lazy(() => import("views/app-views/penghargaan/detail")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "penghargaan-form",
    path: `${APP_PREFIX_PATH}/penghargaan/form/:id?`,
    component: React.lazy(() => import("views/app-views/penghargaan/form")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "penghargaan-riwayat",
    path: `${APP_PREFIX_PATH}/penghargaan/riwayat`,
    component: React.lazy(() => import("views/app-views/penghargaan/riwayat")),
    meta: {
      homeLayout: true,
    },
  },
  // Penunjukan PLH
  {
    key: "penunjukan-plh",
    path: `${APP_PREFIX_PATH}/penunjukan-plh`,
    component: React.lazy(() => import("views/app-views/penunjukan-plh")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "penunjukan-plh-detail",
    path: `${APP_PREFIX_PATH}/penunjukan-plh/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/penunjukan-plh/detail"),
    ),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "penunjukan-plh-form",
    path: `${APP_PREFIX_PATH}/penunjukan-plh/form/:id?`,
    component: React.lazy(() => import("views/app-views/penunjukan-plh/form")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "penunjukan-plh-riwayat",
    path: `${APP_PREFIX_PATH}/penunjukan-plh/riwayat`,
    component: React.lazy(
      () => import("views/app-views/penunjukan-plh/riwayat"),
    ),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "tunpas",
    path: `${APP_PREFIX_PATH}/tunpas`,
    component: React.lazy(() => import("views/app-views/tunpas")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "tunpas-detail",
    path: `${APP_PREFIX_PATH}/tunpas/detail/:id`,
    component: React.lazy(() => import("views/app-views/tunpas/detail")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "tunpas-form",
    path: `${APP_PREFIX_PATH}/tunpas/form/:id?`,
    component: React.lazy(() => import("views/app-views/tunpas/form")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "tunpas-riwayat",
    path: `${APP_PREFIX_PATH}/tunpas/riwayat`,
    component: React.lazy(() => import("views/app-views/tunpas/riwayat")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "arhcive-file",
    path: `${APP_PREFIX_PATH}/arsip-file/:id?`,
    component: React.lazy(() => import("views/app-views/archive")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "slks",
    path: `${APP_PREFIX_PATH}/slks`,
    component: React.lazy(() => import("views/app-views/slks")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "slks-detail",
    path: `${APP_PREFIX_PATH}/slks/detail/:id`,
    component: React.lazy(() => import("views/app-views/slks/detail")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "slks-form",
    path: `${APP_PREFIX_PATH}/slks/form/:id?`,
    component: React.lazy(() => import("views/app-views/slks/form")),
    meta: {
      homeLayout: true,
    },
  },
  {
    key: "slks-riwayat",
    path: `${APP_PREFIX_PATH}/slks/riwayat`,
    component: React.lazy(() => import("views/app-views/slks/riwayat")),
    meta: {
      homeLayout: true,
    },
  },

  // Diklat Ukom
  {
    key: "diklat-ukom",
    path: `${APP_PREFIX_PATH}/diklat-ukom/:id?`,
    component: React.lazy(() => import("views/app-views/diklat-ukom")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "profile-password",
    path: `${APP_PREFIX_PATH}/profile/password`,
    component: React.lazy(() => import("views/app-views/profile/password")),
    meta: {
      customLayout: true,
    },
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
];
